module.exports = __webpack_public_path__ + "static/media/mundoformas.a3dca769.svg";